import {debounce} from 'lodash';
import { Controller } from "@hotwired/stimulus";

/**
 * Mixin for detecting browser resize changes.
 * Note that you can use this mixin only for Stimulus controllers.
 *
 * Usage:
 * import {useResizeListener} from "./mixins/use_resize_listener.js";
 *
 * export default class extends Controller {
 *   connect() {
 *     useResizeListener(this);
 *   }
 *
 *   onZoomChange() {
 *     // callback function
 *   }
 * }
 */
export function useResizeListener(controller, options = {}) {
  const {
    debounceDelay = 100,
    callback = 'onResizeChange'
  } = options;

  if (!(controller instanceof Controller)) {
    console.error('useResizeListener: param controller is not instance of Stimulus Controller');
    throw new Error("useResizeListener: param controller is not instance of Stimulus Controller");
  }

  if (typeof controller[callback] !== 'function') {
    console.error(`useResizeListener: controller.${callback} method is required`);
    throw new Error(`useResizeListener: controller.${callback} method is required`);
  }

  const debouncedCheckResizeChange = debounce(() => {
    controller[callback]();
  }, debounceDelay);

  controller._resizeListener = debouncedCheckResizeChange;

  window.addEventListener('resize', controller._resizeListener);

  const originalDisconnect = controller.disconnect.bind(controller);
  controller.disconnect = function() {
    window.removeEventListener('resize', controller._resizeListener);
    originalDisconnect();
  };
}